// extracted by mini-css-extract-plugin
export var growableInput = "_6d-0";
export var tagContainer = "_6d-2";
export var textInput = "_6d-1";